export default "__VITE_ASSET__BBf5VAmR__"